module.exports = __webpack_public_path__ + "static/media/1.07e2d4a3.svg";